import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getExchangeOrigin } from '@/utils/location';
import ExchangeIcon from '@/components/icons/menu/ExchangeIcon';
import LabsIcon from '@/components/icons/menu/LabsIcon';
import AcademyIcon from '@/components/icons/menu/AcademyIcon';
import RebateIcon from '@/components/icons/menu/RebateIcon';
import ScheduleIcon from '@/components/icons/menu/ScheduleIcon';
import StoreIcon from '@/components/icons/StoreIcon';
import { HeaderItem } from '.';
import TrendsIcon from '@/components/icons/menu/TrendsIcon';
import { useStore } from '@/models';

export const useMoreList = () => {
  const { t } = useTranslation();
  const { account } = useStore();
  const { lang } = account;

  return useMemo<HeaderItem[]>(
    () => [
      {
        children: [
          {
            url: `${getExchangeOrigin()}/tradePro/xt_usdt`,
            title: t('header.menu.05'),
            subTitle: t('header.menu.05sub'),
            icon: <ExchangeIcon />,
          },
          {
            url: `${getExchangeOrigin()}/MegabitStarter`,
            title: t('header.menu.06'),
            subTitle: t('header.menu.06sub'),
            icon: <LabsIcon />,
          },
          {
            url: 'https://labs.megabit.vip/',
            title: t('header.menu.07'),
            subTitle: t('header.menu.07sub'),
            icon: <LabsIcon />,
          },
          {
            url: `${getExchangeOrigin()}/academy`,
            title: t('header.menu.11'),
            subTitle: t('header.menu.11sub'),
            icon: <AcademyIcon />,
          },
          {
            url: 'https://xsc.pub/',
            title: t('header.menu.12'),
            subTitle: t('header.menu.12sub'),
            icon: <LabsIcon />,
          },
          {
            url: `${getExchangeOrigin()}/recommend`,
            title: t('header.menu.08'),
            subTitle: t('header.menu.08sub'),
            icon: <RebateIcon />,
          },
          {
            url: `${getExchangeOrigin()}/schedule`,
            title: t('header.menu.09'),
            subTitle: t('header.menu.09sub'),
            icon: <ScheduleIcon />,
          },
          {
            url: `${getExchangeOrigin()}/xt-social/${lang}`,
            title: t('header.menu.13'),
            subTitle: t('header.menu.13sub'),
            icon: <TrendsIcon />,
          },
        ],
        icon: <StoreIcon />,
        title: t('btn.learnMore'),
        append: (
          <div style={{ color: 'inherit', fontSize: '16px', fontWeight: 'bold' }}>
            <div>{t('header.menu.learn')}</div>
            <div>{t('header.menu.building')}</div>
          </div>
        ),
      },
    ],
    [lang],
  );
};
